export const rectime = (secs) => {
  const hr = Math.floor(secs / 3600);
  let min = Math.floor((secs - hr * 3600) / 60);
  let sec = secs - hr * 3600 - min * 60;

  min = min < 10 ? `0${min}` : min;
  sec = sec < 10 ? `0${sec}` : sec;

  return `${min}:${sec}`;
};

export default rectime;



// WEBPACK FOOTER //
// ./src/common/utils/rectime.js